import { z } from 'zod';
import { UserRefSchema } from '../user-ref';

// Apple device identifiers: 40-hex for pre-2018 devices, `XXXXXXXX-` + 16 hex
// for modern ones. Stored and compared uppercase-normalized.
export const APPLE_UDID_PATTERN = /^([0-9A-F]{40}|[0-9A-F]{8}-[0-9A-F]{16})$/;

export const AppleUdidInputSchema = z
  .string()
  .trim()
  .toUpperCase()
  .pipe(
    z
      .string()
      .regex(
        APPLE_UDID_PATTERN,
        'Not a valid Apple UDID (40 hex chars or XXXXXXXX-XXXXXXXXXXXXXXXX)',
      ),
  );

// Becomes the device name on the Apple Developer portal (50-char limit there);
// tab/newline are the devices.txt field separators, so they can never appear.
export const UdidLabelSchema = z
  .string()
  .trim()
  .min(1)
  .max(50)
  .regex(/^[^\t\n\r]+$/, 'Label must not contain tabs or line breaks');

export const UserAppleUdidSchema = z.object({
  id: z.string().uuid(),
  udid: z.string(),
  label: z.string(),
  registeredAt: z.string().nullable(),
  /** Set when the UDID was confirmed present on the Apple Developer portal. */
  verifiedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type UserAppleUdid = z.infer<typeof UserAppleUdidSchema>;

export const AdminAppleUdidSchema = UserAppleUdidSchema.extend({
  user: UserRefSchema,
  registeredBy: z
    .object({
      id: z.string().uuid(),
      displayName: z.string(),
    })
    .nullable(),
});
export type AdminAppleUdid = z.infer<typeof AdminAppleUdidSchema>;
